import Vue from "vue";
import Router from "vue-router";

import store from "./store"

Vue.use(Router);
function loadView(view) {
  return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`)
}

const router = new Router({
  routes: [{
    path: '/',
    name: 'loginController',
    component: loadView("login"),
    meta: {
      title: 'Login'
    }
  }, {
    path: '/clientSystemLogin',
    name: 'clientSystemLogin',
    component: loadView("clientSystemLogin"),
    meta: {
      title: 'clientSystemLogin'
    }
  }, {
    path: '/version',
    name: 'versionController',
    component: loadView("version"),
    meta: {
      title: 'Version'
    }
  },
  {
    path: '/forgetPassword',
    component: loadView("forgetPassword"),
    meta: {
      title: 'forgetPassword'
    }
  },
  {
    path: "/resetPwd",
    component: loadView("resetPassword"),
    meta: {
      title: 'resetPassword'
    },
  },
  {
    path: "/closeIframe",
    component: loadView("closeIframe"),
    meta: {
      title: '',
    },
  },
  {
    path: "/mapPoiDetail",
    component: loadView("mapPoiDetail"),
    meta: {
      title: 'POI Detail',
    },
  },
  {
    path: "/mapMarkerDetail",
    component: loadView("mapMarkerDetail"),
    meta: {
      title: 'Marker Detail',
    },
  },
  {
    path: "/mapPathDetail",
    component: loadView("mapPathDetail"),
    meta: {
      title: 'Path Detail',
    },
  },
  {
    path: "/main",
    name: "homeController",
    component: () =>
      import("./views/Home.vue"),
    children: [
      {
        path: "homePage",
        component: loadView("homePage"),
        meta: {
          title: 'home',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' }
          ]
        },
      },
      {
        path: "userList",
        component: loadView("userList"),
        meta: {
          title: 'User List',
          pageTip: "userListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/userList', text: 'User List' }
          ]
        },
      },
      {
        path: "userDetail",
        component: loadView("userDetail"),
        meta: {
          title: 'User Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/userList', text: 'User List' },
            { to: '/main/userDetail', text: 'User Detail' }
          ]
        },
      },
      {
        path: "roleList",
        component: loadView("roleList"),
        meta: {
          title: 'Role List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/roleList', text: 'Role List' }
          ]
        },
      },
      {
        path: "roleDetail",
        component: loadView("roleDetail"),
        meta: {
          title: 'Role Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/roleList', text: 'Role List' },
            { to: '/main/roleDetail', text: 'Role Detail' }
          ]
        },
      },
      {
        path: "groupList",
        component: loadView("groupList"),
        meta: {
          title: 'Group List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/groupList', text: 'Group List' }
          ]
        },
      },
      {
        path: "groupDetail",
        component: loadView("groupDetail"),
        meta: {
          title: 'Group Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/groupList', text: 'Group List' },
            { to: '/main/groupDetail', text: 'Group Detail' }
          ]
        },
      },
      {
        path: "landingPage",
        component: loadView("landingPage"),
        meta: {
          title: 'Landing Page Management',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/landingPage', text: 'Landing Page Management' }
          ]
        },
      },
      {
        path: "categoryList",
        component: loadView("categoryList"),
        meta: {
          title: 'Category List',
          pageTip: "categoryListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/categoryList', text: 'Category List' }
          ]
        },
      },
      {
        path: "categoryDetail",
        component: loadView("categoryDetail"),
        meta: {
          title: 'Category Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/categoryList', text: 'Category List' },
            { to: '/main/categoryDetail', text: 'Category Detail' }
          ]
        },
      },
      {
        path: "logList",
        component: loadView("logList"),
        meta: {
          title: 'Log List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/logList', text: 'Log List' }
          ]
        },
      },
      {
        path: "poiList",
        component: loadView("poiList"),
        meta: {
          title: 'POI List',
          pageTip: "poiListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/poiList', text: 'POI List' }
          ]
        },
      },
      {
        path: "poiDetail",
        component: loadView("poiDetail"),
        meta: {
          title: 'POI Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/poiList', text: 'POI List' },
            { to: '/main/poiDetail', text: 'POI Detail' }
          ]
        },
      },
      {
        path: "tagList",
        component: loadView("tagList"),
        meta: {
          title: 'Tag List',
          pageTip: "tagListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagList', text: 'Tag List' }
          ]
        },
      },
      {
        path: "tagDetail",
        component: loadView("tagDetail"),
        meta: {
          title: 'Tag Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagList', text: 'Tag List' },
            { to: '/main/tagDetail', text: 'Tag Detail' }
          ]
        },
      },
      {
        path: "attributeConfigList",
        component: loadView("attributeConfigList"),
        meta: {
          title: 'Attribute Config List',
          pageTip: "attributeConfigListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/attributeConfigList', text: 'Attribute Config List' }
          ]
        },
      },
      {
        path: "attributeConfigDetail",
        component: loadView("attributeConfigDetail"),
        meta: {
          title: 'Attribute Config Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/attributeConfigList', text: 'Attribute Config List' },
            { to: '/main/attributeConfigDetail', text: 'Attribute Config Detail' }
          ]
        },
      },
      {
        path: "promptMessageMaintenanceList",
        component: loadView("promptMessageMaintenanceList"),
        meta: {
          title: 'prompt Message Maintenance List',
          pageTip: "promptMessageMaintenanceList",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/promptMessageMaintenanceList', text: 'prompt Message Maintenance List' }
          ]
        },
      },
      {
        path: "tagGroupList",
        component: loadView("tagGroupList"),
        meta: {
          title: 'Tag Group List',
          pageTip: "tagGroupListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagGroupList', text: 'Tag Group List' }
          ]
        },
      },
      {
        path: "tagGroupDetail",
        component: loadView("tagGroupDetail"),
        meta: {
          title: 'Tag Group Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/tagGroupList', text: 'Tag Group List' },
            { to: '/main/tagGroupDetail', text: 'Tag Group Detail' }
          ]
        },
      },
      {
        path: "projectList",
        component: loadView("projectList"),
        meta: {
          title: 'Project List',
          pageTip: "projectListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/projectList', text: 'Project List' }
          ]
        },
      },
      {
        path: "projectDetail",
        component: loadView("projectDetail"),
        meta: {
          title: 'Project Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/projectList', text: 'Project List' },
            { to: '/main/projectDetail', text: 'Project Detail' }
          ]
        },
      },
      {
        path: "uuidList",
        component: loadView("uuidList"),
        meta: {
          title: 'UUID List',
          pageTip: "uuidListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/uuidList', text: 'UUID List' }
          ]
        },
      },
      {
        path: "uuidDetail",
        component: loadView("uuidDetail"),
        meta: {
          title: 'UUID Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/uuidList', text: 'UUID List' },
            { to: '/main/uuidDetail', text: 'UUID Detail' }
          ]
        },
      },
      {
        path: "beaconList",
        component: loadView("beaconList"),
        meta: {
          title: 'Beacon List',
          pageTip: "beaconListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/beaconList', text: 'Beacon List' }
          ]
        },
      },
      {
        path: "beaconPresetList",
        component: loadView("presetList"),
        meta: {
          title: 'Preset Beacon List',
          pageTip: "beaconPresetListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/beaconPresetList', text: 'beacon Preset List' }
          ]
        },
      },
      {
        path: "beaconPlanningList",
        component: loadView("planningList"),
        meta: {
          title: 'Planning Beacon List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/beaconPlanningList', text: 'beacon Planning List' }
          ]
        },
      },
      {
        path: "beaconPresetList",
        component: loadView("presetList"),
        meta: {
          title: 'Preset Beacon List',
          pageTip: "beaconPresetListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/beaconPresetList', text: 'beacon Preset List' }
          ]
        },
      },
      {
        path: "beaconPlanningList",
        component: loadView("planningList"),
        meta: {
          title: 'Planning Beacon List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/beaconPlanningList', text: 'beacon Planning List' }
          ]
        },
      },
      {
        path: "beaconZoneList",
        component: loadView("beaconZoneList"),
        meta: {
          title: 'Geofencing Zone List',
          pageTip: "beaconZoneListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/beaconZoneList', text: 'Geofencing Zone List' }
          ]
        },
      },
      {
        path: "alertTemplateList",
        component: loadView("alertTemplateList"),
        meta: {
          title: 'Alert Template',
          pageTip: "alertTemplateListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/alertTemplateList', text: 'Alert Template' }
          ]
        },
      },
      {
        path: "baseMap",
        component: loadView("baseMap"),
        meta: {
          title: 'Base Map',
          pageTip: "baseMapTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/baseMap', text: 'Base Map' }
          ]
        },
      },
      {
        path: "baseMapDetail",
        component: loadView("baseMapDetail"),
        meta: {
          title: 'Base Map Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/baseMap', text: 'Base Map' },
            { to: '/main/baseMapDetail', text: 'Base Map Detail' }
          ]
        },
      },
      {
        path: "mapEditorList",
        component: loadView("mapEditorList"),
        meta: {
          title: 'Map Editor',
          pageTip: "mapEditorListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/mapEditorList', text: 'Map Editor' }
          ]
        },
      },
      {
        path: "markerList",
        component: loadView("markerList"),
        meta: {
          title: 'Marker List',
          pageTip: "markerListTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/markerList', text: 'Marker List' }
          ]
        },
      },
      {
        path: "markerDetail",
        component: loadView("markerDetail"),
        meta: {
          title: 'Marker Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/markerList', text: 'Marker List' },
            { to: '/main/markerDetail', text: 'Marker Detail' }
          ]
        },
      },
      {
        path: "heatMap",
        component: loadView("demoReport"),
        meta: {
          title: 'Heat Map',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/heatMap', text: 'Heat Map' }
          ]
        },
      },
      {
        path: "pathWithDwell",
        component: loadView("path"),
        meta: {
          title: 'Path',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/pathWithDwell', text: 'Path' }
          ]
        },
      },
      {
        path: "dailyAverage",
        component: loadView("dailyAverage"),
        meta: {
          title: 'Daily Average Dashboard',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/dailyAverage', text: 'Daily Average Dashboard' }
          ]
        },
      },
      {
        path: "dailyTrend",
        component: loadView("dailyTrend"),
        meta: {
          title: 'Daily Trend',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/dailyTrend', text: 'Daily Trend' }
          ]
        },
      },
      {
        path: "publish",
        component: loadView("publish"),
        meta: {
          title: 'Publish',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/publish', text: 'Publish' }
          ]
        },
      },
      {
        path: "messageList",
        component: loadView("messageList"),
        meta: {
          title: 'Message List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/messageList', text: 'Message List' }
          ]
        },
      },
      {
        path: "messageDetail",
        component: loadView("messageDetail"),
        meta: {
          title: 'Message Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/messageList', text: 'Message List' },
            { to: '/main/messageDetail', text: 'Message Detail' }
          ]
        },
      },
      {
        path: "eventList",
        component: loadView("eventList"),
        meta: {
          title: 'Event',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventList', text: 'Event' }
          ]
        },
      },
      {
        path: "eventDetail",
        component: loadView("eventDetail"),
        meta: {
          title: 'Event Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventList', text: 'Event' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "highlightList",
        component: loadView("highlights"),
        meta: {
          title: 'highlights',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/highlightList', text: 'Highlights' }
          ]
        },
      },
      {
        path: "eventGroupList",
        component: loadView("eventGroupList"),
        meta: {
          title: 'Event Group',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventGroupList', text: 'Event Group' }
          ]
        },
      },
      {
        path: "eventGroupDetail",
        component: loadView("eventGroupDetail"),
        meta: {
          title: 'Event Group Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventGroupList', text: 'Event Group' },
            { to: '/main/eventGroupDetail', text: 'Event Group Detail' }
          ]
        },
      },
      {
        path: "eventDetailHighLight",
        component: loadView("eventDetail"),
        meta: {
          title: 'eventDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/highlightList', text: 'Highlights' },
            { to: '/main/eventDetail', text: 'Event Detail' }
          ]
        },
      },
      {
        path: "eventGroupDetailHighLight",
        component: loadView("eventGroupDetail"),
        meta: {
          title: 'eventGroupDetail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/highlightList', text: 'Highlights' },
            { to: '/main/eventGroupDetail', text: 'Event Group Detail' }
          ]
        },
      },
      {
        path: "eventTypeList",
        component: loadView("eventTypeList"),
        meta: {
          title: 'Event Type List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventTypeList', text: 'Event Type List' }
          ]
        },
      },
      {
        path: "eventTypeDetail",
        component: loadView("eventTypeDetail"),
        meta: {
          title: 'Event Type Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/eventTypeList', text: 'Event Type List' },
            { to: '/main/eventTypeDetail', text: 'Event Type Detail' }
          ]
        },
      },
      {
        path: "venueList",
        component: loadView("eventVenueList"),
        meta: {
          title: 'Venue List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/venueList', text: 'Venue List' }
          ]
        },
      },
      {
        path: "eventVenueDetail",
        component: loadView("eventVenueDetail"),
        meta: {
          title: 'Venue Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/venueList', text: 'Venue List' },
            { to: '/main/eventVenueDetail', text: 'Venue Detail' }
          ]
        },
      },
      {
        path: "hotTagList",
        component: loadView("hotTags"),
        meta: {
          title: 'Hot Tags',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/hotTagList', text: 'Hot Tags' }
          ]
        },
      },
      {
        path: "hotEventList",
        component: loadView("hotEvents"),
        meta: {
          title: 'Hot Events',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/hotEventList', text: 'Hot Events' }
          ]
        },
      },
      {
        path: "messageRuleList",
        component: loadView("messageRuleList"),
        meta: {
          title: 'Message Rule',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/messageRuleList', text: 'Message Rule' }
          ]
        },
      },
      {
        path: "rawData",
        component: loadView("rawData"),
        meta: {
          title: 'Raw Data',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/rawData', text: 'Raw Data' }
          ]
        },
      },
      {
        path: "overview",
        component: loadView("override"),
        meta: {
          title: 'Overview',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/overview', text: 'Overview' }
          ]
        },
      },
      {
        path: "heatMapDwellTime",
        component: loadView("heatMapDwellTime"),
        meta: {
          title: 'Heat Map and Dwell Time',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/heatMapDwellTime', text: 'Heat Map and Dwell Time' }
          ]
        },
      },
      {
        path: "assetZone",
        component: loadView("assetZone"),
        meta: {
          title: 'Asset Zone',
          pageTip: "demoReportTip",
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/assetZone', text: 'Asset Zone' }
          ]
        },
      },
      {
        path: "assetList",
        component: loadView("assetList"),
        meta: {
          title: 'Asset List',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/assetList', text: 'Asset List' }
          ]
        },
      },
      {
        path: "assetDetail",
        component: loadView("assetDetail"),
        meta: {
          title: 'Asset Detail',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/assetList', text: 'Asset List' },
            { to: '/main/assetDetail', text: 'Asset Detail' }
          ]
        },
      },
      {
        path: "geofenceEditorList",
        component: loadView("geofenceEditorList"),
        meta: {
          title: 'Geofence Editor',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/geofenceEditorList', text: 'Geofence Editor' }
          ]
        },
      },
      {
        path: "buildingAreaEditorList",
        component: loadView("buildingAreaEditorList"),
        meta: {
          title: 'Building Area Editor',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/buildingAreaEditorList', text: 'Building Area Editor' }
          ]
        },
      },
      {
        path: "imdfList",
        component: loadView("imdfList"),
        meta: {
          title: 'IMDF',
          breadcrumbs: [
            { to: '/main/homePage', text: 'HomePage' },
            { to: '/main/imdfList', text: 'IMDF' }
          ]
        },
      },
    ]
  },
  ],
})

export default router
